module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 163
// module chunks = 0